// Optional local Firebase config fallback.
// The app still prefers REACT_APP_FIREBASE_* env vars from `.env`.
const firebaseConfig = {
  apiKey: 'AIzaSyC6RIDI7XcgODVSDa3-v9LZgk7NRjxFkGY',
  authDomain: 'disinformationwarriors-9ab94.firebaseapp.com',
  projectId: 'disinformationwarriors-9ab94',
  storageBucket: 'disinformationwarriors-9ab94.firebasestorage.app',
  messagingSenderId: '131822543528',
  appId: '1:131822543528:web:cd2a70f78047f951bd589d',
  measurementId: 'G-0H3RFS1X76',
};

export { firebaseConfig };
export default firebaseConfig;

